export default [
    {
        label: "Yes",
        value: true
    },{
        label: "No",
        value: false
    }
]


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/options/yes-no-options.ts